module.exports = __webpack_public_path__ + "img/3-3.d4a5cdb3.svg";